import env from '../../environment';
import {getCreator, postCreator} from '../../http';

export const endpoints = Object.freeze({
  GET_SESSION: `${env.baseApiUrl}/gusher-gateway/auth/user/session`,
  REFRESH_SESSION: `${env.baseApiUrl}/gusher-gateway/auth/user/session/refresh`,
  LOGIN: `${env.baseApiUrl}/gusher-gateway/auth/user/login`,
  // CREATE_USER: `${env.baseApiUrl}/auth/admin/create-user`,
  LOGOUT: `${env.baseApiUrl}/gusher-gateway/auth/user/logout`,
  FORGOT_PASSWORD: `${env.baseApiUrl}/usher/auth/vendor/forgot-password`,
  RESET_PASSWORD: `${env.baseApiUrl}/usher/auth/vendor/reset-password`,
  GET_DOMAIN_CHANGE_TOKEN: `${env.baseApiUrl}/usher/auth/vendor/token/store-domain-change`,
});

export const getSessionApi = getCreator(endpoints.GET_SESSION);
export const refreshSessionApi = postCreator(endpoints.REFRESH_SESSION);
export const loginApi = postCreator(endpoints.LOGIN);
// export const registerApi = postCreator(endpoints.CREATE_USER);
export const logoutApi = postCreator(endpoints.LOGOUT);
export const sendEmailForgotPasswordApi = postCreator(
  endpoints.FORGOT_PASSWORD
);
export const resetPasswordApi = postCreator(endpoints.RESET_PASSWORD);
export const getDomainChangeTokenApi = postCreator(
  endpoints.GET_DOMAIN_CHANGE_TOKEN
);
